var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"copyright"},[_vm._v("COPYRIGHTⓒ DAVICH OPTICAL. ALL RIGHTS RESERVED.")])])}]

export { render, staticRenderFns }